<div class="app-sidenav" [className]="(isExpanded$ | async) ? 'app-sidenav--expanded' : 'app-sidenav--folded'">
	<mat-nav-list class="app-sidenav__navigation">
		<a mat-list-item class="app-sidenav__link" routerLinkActive="app-sidenav__link--active" routerLink="/welcome">
			<mat-icon matListItemIcon svgIcon="home-solid"></mat-icon>
			<p matListItemLine *ngIf="isExpanded$ | async" i18n>Startseite</p>
		</a>

		<mat-divider></mat-divider>
		<div class="app-sidenav__filler"></div>

		<a mat-list-item class="app-sidenav__link" routerLinkActive="app-sidenav__link--active" routerLink="/search">
			<mat-icon matListItemIcon svgIcon="search-solid"></mat-icon>
			<p matListItemLine *ngIf="isExpanded$ | async" i18n>Werkstoffe und Normen</p>
		</a>

		<a mat-list-item class="app-sidenav__link" routerLinkActive="app-sidenav__link--active" routerLink="/static-page/contact">
			<mat-icon matListItemIcon svgIcon="contact"></mat-icon>
			<p matListItemLine *ngIf="isExpanded$ | async" i18n>Kontakt</p>
		</a>
	</mat-nav-list>
</div>
